import { createSlice } from "@reduxjs/toolkit";
import { sendOverdueEmail, sendReminderEmail } from "./thunk";

export const initialState = {
  isOverdueEmailSent: false,
  isReminderEmailSent: false,
  overdueError: null,
  reminderError: null,
};

const emailSlice = createSlice({
  name: "EmailSlice",
  initialState,
  reducers: {
    resetOverdueState: (state) => {
      state.isOverdueEmailSent = false;
      state.overdueError = null;
    },
    resetReminderState: (state) => {
      state.isReminderEmailSent = false;
      state.reminderError = null;
    },
  },
  extraReducers: (builder) => {
    // ✅ Overdue Email Handling
    builder.addCase(sendOverdueEmail.fulfilled, (state) => {
      state.isOverdueEmailSent = true;
      state.overdueError = null;
    });

    builder.addCase(sendOverdueEmail.rejected, (state, action) => {
      if (action.payload?.alreadySent) {
        state.overdueError = `Overdue email already sent for PVC ${action.payload.pvc_number} in the last 24 hours`;
      } else {
        state.overdueError = action.payload?.error || "Failed to send overdue payment email";
      }
      state.isOverdueEmailSent = false;
    });

    // ✅ Reminder Email Handling
    builder.addCase(sendReminderEmail.fulfilled, (state) => {
      state.isReminderEmailSent = true;
      state.reminderError = null;
    });

    builder.addCase(sendReminderEmail.rejected, (state, action) => {
      if (action.payload?.alreadySent) {
        state.reminderError = `Reminder email already sent for PVC ${action.payload.pvc_number} in the last 24 hours`;
      } else {
        state.reminderError = action.payload?.error || "Failed to send reminder payment email";
      }
      state.isReminderEmailSent = false;
    });
  },
});

export const { resetOverdueState, resetReminderState } = emailSlice.actions;
export default emailSlice.reducer;
